var exports = {
  "z": "xf61da738--4afbd0--root",
  "n": "xf61da738--4afbd0--book-button",
};

module.exports = exports;
